import { FadeUp } from "./Reveal";
import { MapPin, Layers, Weight } from "lucide-react";
import { PROJECTS } from "@/data";

export default function Portfolio() {
  return (
    <section id="work" className="py-24 lg:py-40 bg-[#0A0A0A] border-t border-[#333]" data-testid="portfolio">
      <div className="mx-auto max-w-[1600px] px-6 lg:px-12">
        <FadeUp className="mb-16 lg:mb-24">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-8 h-px bg-[#FF4D00]" aria-hidden="true" />
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF4D00]">Selected Work</span>
          </div>
          <h2 className="font-display font-bold uppercase tracking-tighter text-white text-4xl sm:text-5xl lg:text-7xl leading-[0.9]">
            Structures On<br />The Ground
          </h2>
        </FadeUp>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
          {PROJECTS.map((p, i) => (
            <FadeUp
              key={p.id}
              delay={i * 0.06}
              className={`${p.span} group relative overflow-hidden border border-[#333] min-h-[420px] lg:min-h-[520px]`}
              data-testid={`project-${p.id}`}
            >
              <img
                src={p.image}
                alt={p.name}
                className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 scale-100 group-hover:scale-105 transition-all duration-[900ms] ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />

              <div className="absolute top-6 left-6 flex items-center gap-3">
                <span className="font-mono text-xs uppercase tracking-[0.2em] bg-[#FF4D00] text-black px-3 py-1.5">
                  {p.year}
                </span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-10">
                <h3 className="font-display font-bold uppercase tracking-tight text-white text-3xl lg:text-5xl mb-4">
                  {p.name}
                </h3>
                <div className="flex flex-wrap gap-x-8 gap-y-3 font-mono text-xs uppercase tracking-[0.15em] text-[#A3A3A3] opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                  <span className="flex items-center gap-2">
                    <MapPin size={14} className="text-[#FF4D00]" /> {p.location}
                  </span>
                  <span className="flex items-center gap-2">
                    <Layers size={14} className="text-[#FF4D00]" /> {p.scale}
                  </span>
                  <span className="flex items-center gap-2">
                    <Weight size={14} className="text-[#FF4D00]" /> {p.tonnage}
                  </span>
                </div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
